import api from "../api";
import {iniciarRequisicao} from '../../helpers/index';

class TempoCoberturaPorProduto {
  async getListaFull(headers) {
    const response = await api.get("/compras/tempo-cobertura-curvas-produto", { headers });
    return response;
  }

  async deleteMultiplos(headers, params) {
    const response = await api({
      method: 'delete',
      url: `/compras-delete-multiplos-tempo-cobertura-produto`,
      headers,
      data: params
    });
    return response;
  }

  async store(headers, params) {
    const response = await api({
      method: 'post',
      url: '/compras/tempo-cobertura-curvas-produto',
      headers,
      data: params
    });
    return response;
  }

  async registrarTemposCoberturaProdutoPorFilial(headers, params) {
    const response = await api({
      method: 'post',
      url: '/compras/tempo-cobertura-curvas-produto/registrar-tempos-cobertura-produto-filial',
      headers,
      data: params
    });
    return response;
  }

  async aplicarTempoCobertura(params) {
    const headers = iniciarRequisicao();

    const response = await api({
      method: 'post',
      url: '/compras/tempo-cobertura-curvas-produto/aplica-em-produtos',
      headers,
      data: params
    });
    return response;
  }
}

export default new TempoCoberturaPorProduto();
